// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@adl/App/Store/Reducers";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

interface Size {
    bottom?: number;
    height?: number;
    left?: number;
    right?: number;
    top?: number;
    width?: number;
    x?: number;
    y?: number;
}

export default function useHeaderHeight(): Size {
    const isSticky = useSelector((state: CustomAppState) => state.xHeader.isSticky);
    const [size, setSize] = useState<Size>({});

    useEffect(() => {
        if (typeof document === "undefined") {
            return;
        }
        const headerElement = isSticky
            ? document.getElementById("compact-header")
            : document.getElementById("header-page");
        if (!headerElement) {
            return;
        }

        const observer = new (window as any).ResizeObserver(([entry]: any) => setSize(entry.contentRect));
        observer.observe(headerElement);
        return () => observer.disconnect();
    }, [isSticky]);

    return size || { height: 160 };
}
